<template>
    <div>
        <div>
            <div class="payment-success-screen">
                <div class="message-success">
                    <div class="yes-sure">
                        <img :src="require('@/assets/complete.svg')" alt="">
                        <!-- <van-icon style="font-size: 40px;" name="success" /> -->
                    </div>
                    <b style="font-size: 24px;" :class="{langKh: addFontKhmer}">{{ $t('message.msgTitle') }}</b>
                    <p style="margin-top: 10px;line-height: 27px;" :class="{langKh: addFontKhmer}">{{ $t('message.msg') }}</p>
                </div>
            </div>
        </div>
        <div class="show_container" v-if="checkGoBack()">
            <div class="book_more">
                <div class="d_book_more" @click="clickBack()" :class="{langKh: addFontKhmer}">
                    {{ $t('message.home') }}
                </div>
            </div>
            <div class="show_ticket">
                <div class="d_show_ticket" @click="clickBooking()" :class="{langKh: addFontKhmer}">
                    {{ $t('message.showTicket') }}
                </div>
            </div>
        </div>
        <div class="show_container" v-if="!checkGoBack()" :class="{langKh: addFontKhmer}">
            <div class="book_more">
                <div class="d_book_more" @click="clickBack()" :class="{langKh: addFontKhmer}">
                    {{ $t('message.home') }}
                </div>
            </div>
            <div class="show_ticket">
                <div class="d_show_ticket" @click="clickBookingBack()" :class="{langKh: addFontKhmer}">
                    {{ $t('message.showTicket') }}
                </div>
            </div>
        </div>

        <div v-if="paymentSuInternet">
            <div class="van-overlay" style="z-index: 2001;"></div>
            <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
                <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
                <div class="van-dialog__content">
                    <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
                </div>
                <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                    <button type="button" @click="clickBooking()" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                        <div class="van-button__content">
                            <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                onLine: navigator.onLine,
                addFontKhmer: false,
                paymentSuInternet: false,
            }
        },
        methods: {
            checkInternet() {
                if(!this.onLine){
                   this.paymentSuInternet = true
                }
            },

            clickBack() {
                this.$router.push("/Home");
            },

            clickBooking() {
                let ticketSuccessId = localStorage.getItem("ticketSuccessId");
                localStorage.setItem('idbooking', ticketSuccessId);
                localStorage.setItem('reloadTicket', 1);
                this.$router.push("/ticket-booking");
            },

            clickBookingBack() {
                localStorage.setItem("homepage", "0");
                this.$router.push("/show-ticket");
            },
            
            checkGoBack() {
                let check = false;
                if(localStorage.getItem('dateTo') == null) {
                    check = true;
                }
                return check; 
            },
        },

        created() {
            this.checkInternet();
            this.$bridge.callHandler("setBarTitle", { title: "Payment Success", bgColor: "#de5d0a",color: "#ffffff"});
            if(this.$i18n.locale == "en") {
                this.addFontKhmer = false;
            }else {
                this.addFontKhmer = true;
            }
            localStorage.removeItem('destinationFrom');
            localStorage.removeItem('destinationFromId');
            localStorage.removeItem('destinationTo');
            localStorage.removeItem('destinationToId');
            localStorage.removeItem('dateFrom');
            localStorage.removeItem('dateTo');
            localStorage.removeItem('types');
        },
        mounted() {
            window.onpopstate = () => {
                this.$router.push("/Home");
            };
        },
        beforeUnmount() {
            window.onpopstate = null;
        },
    }
</script>
<style>
    .payment-success-screen {  
        display: flex;
        align-items: center;
        justify-content: center;
        height: 70vh;
        padding-left: 15px;
        padding-right: 15px;
    }
    .payment-success-screen .message-success {
        position: relative;
        border-radius: 8px;
        padding: 60px 15px 15px 15px;
        text-align: center;
        font-size: 18px;
    }
    .show_container {
        display: flex;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 15px;
        box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
    }
    .book_more {
        width: 50%;
        padding-right: 3px;
    }
    .show_ticket {
        width: 50%;
        display: flex;
        justify-content: end;
        padding-left: 3px;
    }
    .d_book_more {
        border-radius: 8px;
        padding: 10px;
        width: 100%;
        text-align: center;
        color: #FFF;
        background: #de5d0a;
        border: 1px solid #de5d0a;
    }
    .d_show_ticket {
        border-radius: 8px;
        padding: 10px;
        width: 100%;
        text-align: center;
        color: #FFF;
        background: #de5d0a;
        border: 1px solid #de5d0a;
    }
    /* .payment-success-screen .message-success .yes-sure {
        border: 1px solid;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        line-height: 100px;
        margin: auto;
        color: #FFFF;
        background: #de5d0a;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    } */
</style>